var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8333 43.3334C54.4526 43.3334 53.3333 44.4527 53.3333 45.8334V47.5C53.3333 48.8808 54.4526 50 55.8333 50H64.1667C65.5474 50 66.6667 48.8808 66.6667 47.5V45.8334C66.6667 44.4527 65.5474 43.3334 64.1667 43.3334H55.8333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8333 46.7277C48.7368 46.8454 47.4133 47.1794 46.4645 48.1283C45 49.5927 45 51.9498 45 56.6638V66.6638C45 71.3779 45 73.7349 46.4645 75.1994C47.9289 76.6638 50.286 76.6638 55 76.6638H65C69.714 76.6638 72.0711 76.6638 73.5355 75.1994C75 73.7349 75 71.3779 75 66.6638V56.6638C75 51.9498 75 49.5927 73.5355 48.1283C72.5867 47.1794 71.2632 46.8454 69.1667 46.7277V47.5C69.1667 50.2615 66.9281 52.5 64.1667 52.5H55.8333C53.0719 52.5 50.8333 50.2615 50.8333 47.5V46.7277ZM65.8529 60.9139C66.3576 60.4428 66.3849 59.6518 65.9138 59.1471C65.4428 58.6425 64.6518 58.6152 64.1471 59.0862L57.8571 64.9569L55.8529 63.0862C55.3482 62.6152 54.5572 62.6425 54.0862 63.1472C53.6151 63.6518 53.6424 64.4428 54.1471 64.9139L57.0042 67.5805C57.4845 68.0288 58.2298 68.0288 58.71 67.5805L65.8529 60.9139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.e01287d6df9c86ef1e34c80f4979d667.svg";
export { ForwardRef as ReactComponent };